export default function BubbleGum() {
	return (
		<iframe
			src='/gum/index.html'
			title='Bubblegum Guessing Game'
			style={{ width: '100%', height: '100%', border: 'none' }}
		/>
	);
}
